var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({color:_vm.jisuan})},[_vm._v(" "+_vm._s(_vm.num)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }